/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState } from 'react';
import { Button as ButtonMui } from '@mui/material';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';

import { IWiseTableAction } from 'components/wise/types';
import { IComponentParams } from 'plugins/api/types';

import { useAppNavigate } from 'hooks';
import * as Components from 'components/containers';
import { Modal } from 'components/controls';
import { DynamicPage } from 'plugins/pages';
import { paramsListToPageUrlParser, paramsToUrlParser } from 'plugins/util/parser';
import { Plus } from 'react-bootstrap-icons';

interface IWiseTableNoContextActionProps {
  action: IWiseTableAction;
  refetch: () => void;
  componentParams?: IComponentParams;
  index: number;
}

type ComponentKeys = 'ClientForm' | 'Order';
type IParamsList = { id?: string; mode?: string };

const WiseTableNoContextAction: FC<IWiseTableNoContextActionProps> = ({
  action,
  refetch,
  componentParams,
  index
}) => {
  const { search } = useLocation();
  const navigate = useAppNavigate();

  const [open, setOpen] = useState(false);

  // Import komponentu po nazwie w definicji akcji
  const componentKey = action?.method_params?.component_name;
  const Component =
    typeof componentKey === 'string' ? Components[componentKey as ComponentKeys] : null;

  // Lista parametrów
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { mode, ...restParams }: IParamsList = qs.parse(
    action.method_params?.params_list?.replaceAll(';', '&') || ''
  );

  const handleButtonClick = () => {
    if (action.method === 'OpenModalComponent' || action.method === 'OpenModalDynamicPage') {
      setOpen(true);
    }

    if (action.method === 'Redirect') {
      const redirectUrl = paramsListToPageUrlParser(
        action.method_params?.page_url || '',
        action.method_params?.params_list || '',
        qs.parse(search)
      );

      if (action.method_params?.page_url) {
        navigate(redirectUrl);
      }
    }

    if (action.method === 'Cancel' && componentParams?.fnCallback) {
      componentParams.fnCallback(false);
    }
  };

  const handleSuccess = () => {
    setOpen(false);

    if (action.refresh_data_mode === 'ONSUCCESS') {
      refetch();
    }
  };

  const renderOpenComponentModal = () => {
    return (
      <Modal onClose={() => setOpen(false)} title="">
        {Component && (
          <Component onCancel={() => setOpen(false)} onSuccess={() => handleSuccess()} />
        )}
      </Modal>
    );
  };

  const renderOpenModalDynamicPage = () => {
    const requestParams = action.method_params?.params_list
      ? qs.parse(paramsToUrlParser(action.method_params.params_list, { ...qs.parse(search) }))
      : {};

    return (
      <Modal fullWidth onClose={() => setOpen(false)} title="">
        <DynamicPage
          pageSymbol={action.method_params?.dynamic_page || ''}
          componentParams={{
            fnCallback: () => setOpen(false),
            isModal: false,
            refetchFn: refetch
          }}
          requestParams={requestParams}
        />
      </Modal>
    );
  };

  const renderContent = () => {
    if (open && action.method === 'OpenModalComponent') {
      return renderOpenComponentModal();
    }

    if (open && action.method === 'OpenModalDynamicPage') {
      return renderOpenModalDynamicPage();
    }

    return null;
  };

  const variant = index === 1 ? 'outlined' : 'contained';

  return (
    <>
      <ButtonMui
        variant={variant}
        color="secondary"
        onClick={() => handleButtonClick()}
        endIcon={action.style === 'ACTION_PLUS' ? <Plus /> : null}
        sx={{
          lineHeight: '28px'
        }}>
        {action.label}
      </ButtonMui>
      {renderContent()}
    </>
  );
};

export default WiseTableNoContextAction;
